import React from 'react';

import { useLingui } from '@lingui/react/macro';
import {
  Button as PFButton,
  ToolbarItem as PFToolbarItem,
} from '@patternfly/react-core';
import { BarsIcon, EqualsIcon } from '@patternfly/react-icons';
import styled from 'styled-components';

const Button = styled(PFButton)`
  padding: 0;
  margin: 0;
  height: 30px;
  width: 30px;
  ${(props) =>
    props.$isActive
      ? `
      background-color: var(--pf-v6-global--primary-color--100);
      --pf-v6-c-button--m-plain--active--Color: white;
      --pf-v6-c-button--m-plain--focus--Color: white;`
      : null};
`;

const ToolbarItem = styled(PFToolbarItem)`
  & :not(:last-child) {
    margin-right: 20px;
  }
`;

// TODO: Recommend renaming this component to avoid confusion
// with ExpandingContainer
function ExpandCollapse({ isCompact = true, onCompact, onExpand }) {
  const { t } = useLingui();
  return (
    <>
      <ToolbarItem>
        <Button
          ouiaId="toolbar-collapse-button"
          variant="plain"
          aria-label={t`Collapse`}
          onClick={onCompact}
          $isActive={isCompact}
        >
          <BarsIcon />
        </Button>
      </ToolbarItem>
      <ToolbarItem>
        <Button
          ouiaId="toolbar-expand-button"
          variant="plain"
          aria-label={t`Expand`}
          onClick={onExpand}
          $isActive={!isCompact}
        >
          <EqualsIcon />
        </Button>
      </ToolbarItem>
    </>
  );
}

export default ExpandCollapse;
